<template>
    <div>
        <el-dialog :title="$t('editShop')"
                   :visible.sync="dialogVisible"
                   :close-on-click-modal="false"
                   @close="dialogClose"
                   center
                   custom-class="medium-dialog"
                   top="5vh">
            <div class="content">
                <el-form :model="formData"
                         size="mini"
                         :rules="rules"
                         ref="ruleForm"
                         label-width="110px">
                    <el-form-item :label="$t('merchant')"
                                  prop="merchantId">
                        <el-select v-model="formData.merchantId" filterable @change="merchantChange">
                            <el-option v-for="item in merchantOptions"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('shopName')"
                                  prop="name">
                        <el-input v-model="formData.name"
                                  autocomplete="off"></el-input>
                    </el-form-item>
                    <div class="form-two">
                        <el-form-item :label="$t('country')"
                                      prop="country">
                            <el-input v-model="formData.country"
                                      autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('province')"
                                      prop="province">
                            <el-input v-model="formData.province"
                                      autocomplete="off"></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-two">
                        <el-form-item :label="$t('city')"
                                      prop="city">
                            <el-input v-model="formData.city"
                                      autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('postcode')"
                                      prop="zipcode">
                            <el-input v-model="formData.zipcode"
                                      autocomplete="off"></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item :label="$t('address')"
                                  prop="address">
                        <el-input v-model="formData.address"
                                  autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item class="form-group" :label="$t('coordinate')" required>
                        <el-col :span="8">
                            <el-form-item prop="longitude">
                                <el-input type="number" size="small" v-model="formData.longitude" autocomplete="off" :placeholder="$t('longitude')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="1">&nbsp;</el-col>
                        <el-col :span="8">
                            <el-form-item prop="latitude">
                                <el-input type="number" v-model="formData.latitude" autocomplete="off" :placeholder="$t('latitude')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="1">&nbsp;</el-col>
                        <el-col :span="6">
                            <el-button type="primary" size="mini" @click="mapDialog = true">{{ $t('select') }}</el-button>
                        </el-col>
                    </el-form-item>
                    <div class="form-two">
                        <el-form-item :label="$t('linkman')"
                                      prop="contactName">
                            <el-input v-model="formData.contactName"
                                      autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('contactPhone')"
                                      prop="contactPhone">
                            <el-input v-model="formData.contactPhone"
                                      autocomplete="off"></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-two">
                        <el-form-item :label="$t('email')"
                                      prop="contactEmail">
                            <el-input v-model="formData.contactEmail"
                                      autocomplete="off"></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item label="Logo" prop="logo">
                        <el-upload
                            class="avatar-uploader"
                            :show-file-list="false"
                            action=""
                            :http-request="httpRequest"
                            accept="image/jpg,image/jpeg,image/png,image/gif">
                            <img :src="formData.logo" class="avatar" v-if="formData.logo">
                            <div class="avatar-icon">
                                <i class="el-icon-delete" @click.stop="handleRemoveImage" v-if="formData.logo"></i>
                                <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <div class="service">
                    <div class="service-header">
                        <span class="label">{{ $t('businessTime') }}</span>
                        <el-button type="primary" size="mini" @click="addServiceHandle">{{ $t('add') }}</el-button>
                    </div>
                    <el-form v-for="(item, index) in serviceForm.list" :key="index" :model="item" size="mini" :ref="`serviceForm${index}`" :rules="rules" label-width="110px">
                        <el-form-item :label="$t('week')">
                            <el-col :span="9">
                                <el-form-item prop="startWeek">
                                    <el-select v-model="item.startWeek" @change="weekChang(index)" style="width: 100%;">
                                        <el-option v-for="item in weekOptions"
                                                   :key="item.value"
                                                   :label="item.label"
                                                   :value="item.value"
                                                   :disabled="item.disabled">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col class="line" :span="2">-</el-col>
                            <el-col :span="9">
                                <el-form-item prop="endWeek">
                                    <el-select v-model="item.endWeek" @change="weekChang(index)" style="width: 100%;">
                                        <el-option v-for="item in weekOptions"
                                                   :key="item.value"
                                                   :label="item.label"
                                                   :value="item.value"
                                                   :disabled="item.disabled">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4" class="form-handle">
                                <i class="el-icon-delete red" @click="deleteServiceHandle(index)"></i>
                            </el-col>
                        </el-form-item>
                        <el-form-item :label="$t('timeFrame')" v-for="(inItem, inIndex) in item.times" :key="inIndex">
                            <el-col :span="9">
                                <el-form-item prop="startTime">
                                    <el-time-picker
                                        arrow-control
                                        format="HH:mm"
                                        value-format="HH:mm"
                                        :placeholder="$t('selectTime')"
                                        v-model="inItem.startTime"
                                        style="width: 100%;">
                                    </el-time-picker>
                                </el-form-item>
                            </el-col>
                            <el-col class="line" :span="2">-</el-col>
                            <el-col :span="9">
                                <el-form-item prop="endTime">
                                    <el-time-picker
                                        arrow-control
                                        format="HH:mm"
                                        value-format="HH:mm"
                                        :placeholder="$t('selectTime')"
                                        v-model="inItem.endTime"
                                        style="width: 100%;">
                                    </el-time-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4" class="form-handle">
                                <i class="el-icon-circle-plus-outline blue" @click="addTimeHandle(index)" v-if="inIndex === item.times.length-1"></i>
                                <i class="el-icon-delete red" @click="deleteTimeHandle(index, inIndex)" v-if="inIndex !== 0"></i>
                            </el-col>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div slot="footer"
                 class="dialog-footer">
                <el-button
                    size="mini"
                    @click="dialogVisible = false">{{ $t('cancel') }}
                </el-button>
                <el-button
                    type="primary"
                    size="mini"
                    :disabled="disabled"
                    @click="submitForm('ruleForm')">{{ $t('confirm') }}
                </el-button>
            </div>
        </el-dialog>
        <Map
            :parent-dialog="mapDialog"
            :parent-longitude="formData.longitude"
            :parent-parentLatitude="formData.latitude"
            @parent-update="mapUpdate"
            @parent-close="mapDialog = false"/>
    </div>
</template>

<script>
import {
    queryShopDetails,
    uploadImage,
    updateShop,
    searchMerchantList
} from "@/api/modules/api";
import Map from '@/components/merchant/shop/Map'
export default {
    name: 'Edit',
    props: {
        parentDialog: {
            type: Boolean,
            default: true
        },
        parentId: {
            type: String,
            default: ''
        },
    },
    // 组件
    components: {
        Map
    },
    data () {
        // 经度
        let validatorLongitude = (rule, value, callback) => {
            const reg = /^(-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,15})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,15}|180)$/
            if (value === "") {
                callback(new Error(this.$t('pleaseInputHint')))
            } else {
                if (!reg.test(value)) {
                    callback(new Error(`${this.$t('lonScope')}-180~180`))
                } else {
                    callback()
                }
            }
        }
        // 纬度
        let validatorLatitude = (rule, value, callback) => {
            const reg = /^(-|\+)?([0-8]?\d{1}\.\d{0,15}|90\.0{0,15}|[0-8]?\d{1}|90)$/
            if (value === "") {
                callback(new Error(this.$t('pleaseInputHint')))
            } else {
                if (!reg.test(value)) {
                    callback(new Error(`${this.$t('latScope')}-90~90`));
                }
                callback();
            }
        }
        return {
            dialogVisible: false,
            merchantOptions: [],
            weekOptions: [
                {
                    value: 1,
                    label: this.$t('week1'),
                    disabled: false
                },
                {
                    value: 2,
                    label: this.$t('week2'),
                    disabled: false
                },
                {
                    value: 3,
                    label: this.$t('week3'),
                    disabled: false
                },
                {
                    value: 4,
                    label: this.$t('week4'),
                    disabled: false
                },
                {
                    value: 5,
                    label: this.$t('week5'),
                    disabled: false
                },
                {
                    value: 6,
                    label: this.$t('week6'),
                    disabled: false
                },
                {
                    value: 7,
                    label: this.$t('week7'),
                    disabled: false
                }
            ],
            formData: {
                merchantId: '',
                name: '',
                country: '',
                province: '',
                city: '',
                zipcode: '',
                address: '',
                longitude: '',
                latitude: '',
                contactName: '',
                contactPhone: '',
                contactEmail: '',
                logo: ''
            },
            serviceForm: {
                list: []
            },
            rules: {
                merchantId: [{ required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
                name: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                longitude: [{ required: true, validator: validatorLongitude, trigger: 'blur' }],
                latitude: [{ required: true, validator: validatorLatitude, trigger: 'blur' }],
                startWeek: [{ required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
                endWeek: [{ required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
            },
            disabled: false,
            mapDialog: false,
        }
    },
    created () { },
    mounted () { },
    watch: {
        parentDialog (val) {
            if (val) {
                this.initData()
            }
        },
    },
    methods: {
        // 初始化数据
        initData () {
            this.dialogVisible = true
            this.serviceForm.list = []
            this.weekOptions = this.weekOptions.map(item => {
                return {
                    value: item.value,
                    label: item.label,
                    disabled: false
                }
            })
            // 获取详情
            this.getDetails()
            if (this.merchantOptions.length === 0) {
                // 获取商家列表
                this.getMerchantOptions()
            }
        },
    
        // 获取详情
        getDetails () {
            queryShopDetails(this.parentId).then((res) => {
                if (Number(res.code) === 20000) {
                    let resData = res.data
                    this.formData = {
                        merchantId: resData.merchantId,
                        name: resData.name || '',
                        country: resData.country || '',
                        province: resData.province || '',
                        city: resData.city || '',
                        zipcode: resData.zipcode || '',
                        address: resData.address || '',
                        longitude: resData.longitude || '',
                        latitude: resData.latitude || '',
                        contactName: resData.contactName || '',
                        contactPhone: resData.contactPhone || '',
                        contactEmail: resData.contactEmail || '',
                        logo: resData.logo || ''
                    }
                    // 初始化营业时间
                    this.initServiceTime(resData.serviceTimes)
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            });
        
        },
        
        /******** 营业时间回显 ********/
        initServiceTime (data) {
            if (!(data instanceof Array) || data.length === 0) return
            // 获取每日时段
            let weekArr = this.getWeekTimes(data)
            // 按照星期排序
            let weekSort = weekArr.sort((a, b) => {
                return a.dayOfWeek - b.dayOfWeek
            })
            // 服务时间列表
            let serviceList = []
            // 星期几
            let dayOfWeek = -9
            // 当前时段
            let times = []
            weekSort.forEach(item => {
                // 将星期参数设置为不可选
                let weekData = this.weekOptions[item.dayOfWeek-1]
                weekData.disabled = true
                this.$set(this.weekOptions, item.dayOfWeek-1, weekData)
                if (item.dayOfWeek === (++dayOfWeek) && this.compareArrayIdentical(item.times, times)) {
                    serviceList[serviceList.length - 1].endWeek = item.dayOfWeek
                } else {
                    dayOfWeek = item.dayOfWeek
                    times = item.times
                    let newTimes = times.map(timeItem => {
                        return {
                            startTime: this.insertStr(timeItem.startTime, 2, ':'),
                            endTime: this.insertStr(timeItem.endTime, 2, ':'),
                        }
                    })
                    serviceList.push({
                        startWeek: item.dayOfWeek,
                        endWeek: item.dayOfWeek,
                        times: newTimes
                    })
                }
            })
            this.serviceForm.list = serviceList
        },
        // 获取每日时段数组
        getWeekTimes (arr) {
            let map = {}, result = [];
            for(let i = 0; i < arr.length; i++){
                if(!map[arr[i].dayOfWeek]){
                    result.push({
                        id: arr[i].id,
                        dayOfWeek: arr[i].dayOfWeek,
                        times: [{
                            startTime: arr[i].startTime,
                            endTime: arr[i].endTime
                        }]
                    });
                    map[arr[i].dayOfWeek] = true
                }else{
                    for(var j = 0; j < result.length; j++){
                        if(result[j].dayOfWeek === arr[i].dayOfWeek){
                            result[j].times.push({
                                startTime: arr[i].startTime,
                                endTime: arr[i].endTime
                            });
                            break;
                        }
                    }
                }
            }
            return result;
        },
        // 比较时段数组差异
        compareArrayIdentical (arr1, arr2) {
            let newArr1 = arr1.sort((a, b) => {
                return a.startTime - b.startTime
            })
            let newArr2 = arr2.sort((a, b) => {
                return a.startTime - b.startTime
            })
            return JSON.stringify(newArr1) == JSON.stringify(newArr2)
        },
        // 在指定位置添加字符
        insertStr (source, start, newStr) {
            return source.toString().slice(0, start) + newStr + source.toString().slice(start)
        },
    
        // 获取商家列表
        getMerchantOptions() {
            const params = {
                name: ''
            }
            searchMerchantList(params).then(res => {
                if (Number(res.code) === 20000) {
                    this.merchantOptions = res.data || []
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
    
        // 切换商家
        merchantChange (val) {
            let nowMerchant = this.merchantOptions.find(item => {
                return item.id === val
            })
            this.formData.logo = nowMerchant.logo || ''
        },
    
        /******** 营业时间 ********/
        // 添加星期
        addServiceHandle () {
            this.serviceForm.list.push({
                startWeek: '',
                endWeek: '',
                times: [
                    {
                        startTime: '',
                        endTime: ''
                    }
                ]
            })
        },
        // 删除星期
        deleteServiceHandle (index) {
            // 恢复星期可选
            let nowData = this.serviceForm.list[index]
            if (nowData.startWeek && nowData.endWeek) {
                let difference = 0
                let week = nowData.startWeek
                if (nowData.startWeek <= nowData.endWeek) {
                    difference = nowData.endWeek - nowData.startWeek
                } else {
                    difference = nowData.startWeek - nowData.endWeek
                    week = nowData.endWeek
                }
                for (let i=0; i<=difference; i++) {
                    let weekData = this.weekOptions[week-1+i]
                    weekData.disabled = false
                    this.$set(this.weekOptions, week-1+i, weekData)
                }
            }
            // 删除项
            this.serviceForm.list.splice(index, 1)
        },
        // 添加时间
        addTimeHandle (index) {
            this.serviceForm.list[index].times.push({
                startTime: '',
                endTime: ''
            })
        },
        // 删除时间
        deleteTimeHandle (index, inIndex) {
            this.serviceForm.list[index].times.splice(inIndex, 1)
        },
        // 星期是否可选
        weekChang (index) {
            let nowData = this.serviceForm.list[index]
            if (!nowData.startWeek || !nowData.endWeek) return
            let difference = 0
            let week = nowData.startWeek
            if (nowData.startWeek <= nowData.endWeek) {
                difference = nowData.endWeek - nowData.startWeek
            } else {
                difference = nowData.startWeek - nowData.endWeek
                week = nowData.endWeek
            }
            for (let i=0; i<=difference; i++) {
                let weekData = this.weekOptions[week-1+i]
                weekData.disabled = true
                this.$set(this.weekOptions, week-1+i, weekData)
            }
        },
        
        /******** 图片 ********/
        httpRequest(val) {
            let formData = new FormData();
            formData.append("file", val.file);
            uploadImage(formData)
                .then(res => {
                    if (Number(res.code) === 20000) {
                        this.formData.logo = res.data.url;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err);
                })
        },
        // 清除图片
        handleRemoveImage () {
            this.formData.logo = ''
        },
        
        // 经纬度
        mapUpdate (data) {
            let {longitude, latitude} = data
            this.formData.longitude = longitude
            this.formData.latitude = latitude
        },
    
        // 验证表单
        submitForm (formName) {
            Promise.all([
                this.validateBasicForm(formName),
                ...this.serviceForm.list.map((item,index)=> this.validateServiceForm(`serviceForm${index}`))
            ]).then((res) =>{
                this.validateTimeFrame()
            }).catch((err) => {
                return false
            })
        },
        // 校验基础表单
        validateBasicForm (formName) {
            return new Promise((resolve,reject)=>{
                this.$refs[formName].validate(res => {
                    if(res) resolve()
                    else reject()
                })
            })
        },
        // 验证服务时间表单
        validateServiceForm(formName){
            let valiForm = this.$refs[formName].validate ? this.$refs[formName] : this.$refs[formName][0]
            return new Promise((resolve,reject)=>{
                valiForm.validate(res=>{
                    if(res) resolve()
                    else reject()
                })
            })
        },
        // 校验时段
        validateTimeFrame () {
            let list = this.serviceForm.list
            for (let i=0; i<list.length; i++) {
                for (let j=0; j<list[i].times.length; j++) {
                    if (!list[i].times[j].startTime || !list[i].times[j].endTime) {
                        this.$message({
                            showClose: true,
                            message: this.$t('selectTime'),
                            type: 'warning'
                        });
                        return
                    }
                }
            }
            this.sendRequest()
        },
        // 重置表单
        resetForm (formName) {
            this.$refs[formName].resetFields()
        },
        // 提交
        sendRequest () {
            let serviceTimes = []
            this.serviceForm.list.forEach(item => {
                if (item.startWeek && item.endWeek) {
                    let difference = 0
                    let week = item.startWeek
                    if (item.startWeek <= item.endWeek) {
                        difference = item.endWeek - item.startWeek
                    } else {
                        difference = item.startWeek - item.endWeek
                        week = item.endWeek
                    }
                    for (let i=0; i<=difference; i++) {
                        for (let j=0; j<item.times.length; j++) {
                            serviceTimes.push({
                                dayOfWeek: week + i,
                                startTime: item.times[j].startTime.replace(/:/g, ''),
                                endTime: item.times[j].endTime.replace(/:/g, ''),
                                tomorrow: 0
                            })
                        }
                    }
                }
            })
            const params = {
                id: this.parentId,
                merchantId: this.formData.merchantId,
                name: this.formData.name.trim(),
                country: this.formData.country.trim(),
                province: this.formData.province.trim(),
                city: this.formData.city.trim(),
                address: this.formData.address.trim(),
                zipcode: this.formData.zipcode.trim(),
                latitude: this.formData.latitude,
                longitude: this.formData.longitude,
                contactName: this.formData.contactName.trim(),
                contactPhone: this.formData.contactPhone.trim(),
                contactEmail: this.formData.contactEmail.trim(),
                serviceTimes: serviceTimes,
                logo: this.formData.logo
            }
            this.disabled = true;
            updateShop(params).then((res) => {
                this.disabled = false;
                if (Number(res.code) === 20000) {
                    this.dialogVisible = false
                    this.$emit('parent-update')
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.disabled = false;
                this.$message.error(err);
            });
        },
        // 关闭弹窗
        dialogClose () {
            // 重置表单
            this.resetForm('ruleForm')
            this.$emit('parent-close')
        }
    },
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/form-dialog.scss';
.service{
    margin-top: 10px;
    .service-header{
        padding-bottom: 10px;
        .label{
            margin-left: 10px;
            margin-right: 20px;
        }
    }
    ::v-deep .el-form{
        padding-bottom: 20px;
        .line{
            text-align: center;
        }
        .form-handle{
            text-align: center;
            i{
                font-size: 24px;
                margin-right: 10px;
                cursor: pointer;
                &:last-of-type{
                    margin-right: 0;
                }
            }
        }
    }
}
</style>
